// imports
import { useNavigate, useLocation } from 'react-router-dom'

// components
import { ItemProps } from './types/ItemTypes'
import NavTooltip from './NavTooltip'
import Badge from '@/ui/components/Badge/Badge'
import { DisplayMode } from '@/ui/types/DisplayMode'

// utils
import useWindowSize from '@/hooks/useWindowSize'
import AssistantIcon from '@/ui/components/AssistantIcon/AssistantIcon'

// styles
import './Item.scss'

const Item = ({ icon, iconSrc, label, menuItemTooltipLabel, action, link, isMenuOpen, toggleMenu, isActive, activePath, badges }: ItemProps) => {
    const navigate = useNavigate()
    const { pathname } = useLocation()
    const { isMobile } = useWindowSize()

    const handleClick = (): void => {
        if (action) {
            toggleMenu(false)
            action()
        }
        else if (link)
            navigate(link)
    }

    if (!action && !link)
        console.warn(`Item <${label}> must have either an action or a link`)

    const hasBadges = (badges?.length ?? 0) > 0

    const badgeMode = isMobile ? DisplayMode.MOBILE : DisplayMode.DEFAULT

    return (
        <li className={`a-menu-item ${isActive === (activePath ?? pathname) ? 'active' : ''}`} role='none'>
            <div className='a-menu-item__wrapper'>
                <NavTooltip content={menuItemTooltipLabel ?? label}>
                    <button
                        type='button'
                        role='menuitem'
                        className='a-menu-item__link'
                        onClick={handleClick}
                    >
                        <AssistantIcon icon={icon} iconSrc={iconSrc} alt={label} title={label} className='button-icon' />
                        {
                            isMenuOpen &&
                            <>
                                <span className='a-menu-item__label'>{label}</span>
                                {
                                    hasBadges &&
                                    <Badge
                                        badges={badges}
                                        mode={badgeMode}
                                        position='top-left'
                                    />
                                }
                            </>
                        }
                    </button>
                </NavTooltip>
            </div>
        </li>
    )
}

export default Item
